"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencyPriceProperty = exports.isCurrencyPriceProperty = exports.ORDER = exports.LINE_ITEM_CURRENCY_CODE = exports.UNIT_COST = exports.TERM = exports.START_DATE = exports.RECURRING_BILLING_FREQUENCY = exports.QUANTITY = exports.PRICE = exports.DISCOUNT_PERCENTAGE = exports.DISCOUNT = exports.DESCRIPTION = exports.CREATE_DATE = exports.NAME = void 0;
var NAME = 'name';
exports.NAME = NAME;
var CREATE_DATE = 'createdate';
exports.CREATE_DATE = CREATE_DATE;
var DESCRIPTION = 'description';
exports.DESCRIPTION = DESCRIPTION;
var DISCOUNT = 'discount';
exports.DISCOUNT = DISCOUNT;
var DISCOUNT_PERCENTAGE = 'hs_discount_percentage';
exports.DISCOUNT_PERCENTAGE = DISCOUNT_PERCENTAGE;
var PRICE = 'price';
exports.PRICE = PRICE;
var QUANTITY = 'quantity';
exports.QUANTITY = QUANTITY;
var RECURRING_BILLING_FREQUENCY = 'recurringbillingfrequency';
exports.RECURRING_BILLING_FREQUENCY = RECURRING_BILLING_FREQUENCY;
var START_DATE = 'hs_recurring_billing_start_date';
exports.START_DATE = START_DATE;
var TERM = 'hs_recurring_billing_period';
exports.TERM = TERM;
var UNIT_COST = 'hs_cost_of_goods_sold';
exports.UNIT_COST = UNIT_COST;
var LINE_ITEM_CURRENCY_CODE = 'hs_line_item_currency_code';
exports.LINE_ITEM_CURRENCY_CODE = LINE_ITEM_CURRENCY_CODE;
var ORDER = 'hs_position_on_quote';
exports.ORDER = ORDER;
var currencyPricePrefix = 'hs_price_';

var isCurrencyPriceProperty = function isCurrencyPriceProperty(propertyName) {
  return propertyName.indexOf(currencyPricePrefix) === 0;
};

exports.isCurrencyPriceProperty = isCurrencyPriceProperty;

var getCurrencyPriceProperty = function getCurrencyPriceProperty(currencyCode) {
  return "" + currencyPricePrefix + currencyCode.toLowerCase();
}; // TODO: Add Shopify prop names here


exports.getCurrencyPriceProperty = getCurrencyPriceProperty;